import { Box, Card, Container, Typography, Toolbar, Stack, Divider } from '@mui/material'
import React from 'react'
import Footer from '../Components/Footer'
import ViewNews from '../Components/ViewNews'

export default function News() {
    const news = [
        "The HPC Nexus Laboratory launch ceremony took place on May 23, 2024, at the School of Informatics and Cybersecurity, TU Dublin. The event was graced by faculty members, associated academics, industry professionals, and postgraduate students. We extend a heartfelt thank you to everyone who attended and contributed to making this event a memorable one. The HPC Nexus Laboratory is the first dedicated centre for High-Performance Computing research at TU Dublin. This new facility marks a significant step forward in our ongoing commitment to enhancing research in HPC and becoming a hub of innovation and collaboration. &nbsp;< a href = \"https://www.linkedin.com/posts/tu-dublin-school-of-informatics-and-cybersecurity_the-tu-dublin-school-of-informatics-and-activity-7199772206778695680-EkMy?utm_source=share&utm_medium=member_desktop\" > Click to See More...</a >",
        "HPC Nexus Lab hosted the first #ResearchConnect meetup for TU Dublin - School of Informatics and Cybersecurity researchers! hashtag#ResearchConnect is a monthly event aimed at bringing together researchers and research-curious staff for a coffee, a chat, and some inspiring discussions. It offers a great opportunity for in-person meetups to strengthen the school’s research culture and community. At our first meetup, we had some fantastic talks: Dr matt smith, Senior Lecturer, shared insights on his research using rule - based(explainable!) AI and mathematics to generate candidate user mouse paths and measure similarity to actual paths in web tasks. & nbsp;< a href=\"https://www.linkedin.com/posts/hpc-nexus-lab_researchconnect-researchconnect-researchconnect-activity-7238829490477441024-QCFj/\" > Click to See More...</a >"
    ]
    const images = [
        ["/images/news_images/hpc_nexus_launch.jpeg", "/images/news_images/hpc_nexus_launch2.jpeg", "/images/news_images/hpc_nexus_launch3.jpeg"],
        ["/images/news_images/meetup_news/1.jpg", "/images/news_images/meetup_news/2.jpg", "/images/news_images/meetup_news/3.jpg", "/images/news_images/meetup_news/4.jpg"]
    ]
    return (
        <React.Fragment>
            <Box >
                <br />
                <Typography variant='h3' component='h3' sx={{ marginLeft: "auto", marginRight: "auto" }}>
                    News
                </Typography>
                <br />
                <center>
                    <Box width={"99%"} height={"3px"} sx={{ background: "#e1e1e1", textAlign: 'left', padding: 0 }} />
                </center>
                <br />

                <Box style={{ textAlign: "start", alignItems: "initial", padding: 10 }}>
                    <table >

                        <tr>
                            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>

                                <td >
                                    <Typography variant='h5'>#ResearchConnect meetup</Typography>
                                    <br />
                                    HPC Nexus Lab hosted the first #ResearchConnect meetup for TU Dublin - School of Informatics and Cybersecurity researchers! hashtag#ResearchConnect is a monthly event aimed at bringing together researchers and research-curious staff for a coffee, a chat, and some inspiring discussions. It offers a great opportunity for in-person meetups to strengthen the school’s research culture and community.

                                    At our first meetup, we had some fantastic talks: Dr matt smith, Senior Lecturer, shared insights on his research using rule-based (explainable!) AI and mathematics to generate candidate user mouse paths and measure similarity to actual paths in web tasks. &nbsp;

                                    < a href="https://www.linkedin.com/posts/hpc-nexus-lab_researchconnect-researchconnect-researchconnect-activity-7238829490477441024-QCFj/" > Click to See More...</a >

                                </td>
                                <br />

                                <td>
                                    <ViewNews news={news[1]} images={images[1]} />
                                </td>
                            </Stack>
                        </tr>
                        <br />
                        <center>
                            <Box width={"100%"} height={"3px"} sx={{ background: "#e1e1e1", textAlign: 'left', padding: 0 }} />
                        </center>
                        <br />
                        <tr>
                            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                                <td >
                                    <Typography variant='h5'>HPC Nexus Laboratory - Announcement</Typography>
                                    <br />
                                    The HPC Nexus Laboratory launch ceremony took place on May 23, 2024, at the School of Informatics and Cybersecurity, TU Dublin. The event was graced by faculty members, associated academics, industry professionals, and postgraduate students. We extend a heartfelt thank you to everyone who attended and contributed to making this event a memorable one. The HPC Nexus Laboratory is the first dedicated centre for High-Performance Computing research at TU Dublin. This new facility marks a significant step forward in our ongoing commitment to enhancing research in HPC and becoming a hub of innovation and collaboration. &nbsp;

                                    < a href="https://www.linkedin.com/posts/tu-dublin-school-of-informatics-and-cybersecurity_the-tu-dublin-school-of-informatics-and-activity-7199772206778695680-EkMy?utm_source=share&utm_medium=member_desktop" > Click to See More...</a >

                                </td>
                                <br />

                                <td>
                                    <ViewNews news={news[0]} images={images[0]} />
                                </td>
                            </Stack>
                        </tr>
                        <br />

                    </table>
                </Box>

            </Box>
        </React.Fragment >
    )
}
